const patternBg = `/assets/images/patternbackground.png`;
const arrowDown = `/app/images/arrow--down.svg`;

export { patternBg, arrowDown };
